var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatrix3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 230,
    viewBox: "0 0 4 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92964 170.57L2.52965 169.97H0.139648L0.739655 170.57H1.92964Z",
    fill: "url(#paint0_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 171.9L2.37032 172.2L2.67032 171.9V170.11L2.07031 170.71V171.9Z",
    fill: "url(#paint1_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 172.79V173.97L2.67032 174.57V172.79L2.37032 172.49L2.07031 172.79Z",
    fill: "url(#paint2_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 174.11L0.139648 174.72H2.52965L1.92964 174.11H0.739655Z",
    fill: "url(#paint3_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 172.79L0.300003 172.49L0 172.79V174.57L0.600006 173.97V172.79Z",
    fill: "url(#paint4_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740433 172.04L0.44043 172.34L0.740433 172.64H1.93042L2.23042 172.34L1.93042 172.04H0.740433Z",
    fill: "url(#paint5_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 170.71L0 170.11V171.9L0.300003 172.2L0.600006 171.9V171.61V170.71Z",
    fill: "url(#paint6_linear_2371_121359)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92964 165.09L2.52965 164.48H0.139648L0.739655 165.09H1.92964Z",
    fill: "url(#paint7_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 167.3V168.49L2.67032 169.09V167.3L2.37032 167L2.07031 167.3Z",
    fill: "url(#paint8_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 168.63L0.139648 169.23H2.52965L1.92964 168.63H0.739655Z",
    fill: "url(#paint9_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740433 166.56L0.44043 166.86L0.740433 167.16H1.93042L2.23042 166.86L1.93042 166.56H0.740433Z",
    fill: "url(#paint10_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 165.23L0 164.63V166.41L0.300003 166.71L0.600006 166.41V166.12V165.23Z",
    fill: "url(#paint11_linear_2371_121359)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.91
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92964 159.6L2.52965 159H0.139648L0.739655 159.6H1.92964Z",
    fill: "url(#paint12_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 160.93L2.37032 161.23L2.67032 160.93V159.14L2.07031 159.74V160.93Z",
    fill: "url(#paint13_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 161.81V163L2.67032 163.6V161.81L2.37032 161.51L2.07031 161.81Z",
    fill: "url(#paint14_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 163.14L0.139648 163.74H2.52965L1.92964 163.14H0.739655Z",
    fill: "url(#paint15_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740433 161.07L0.44043 161.37L0.740433 161.67H1.93042L2.23042 161.37L1.93042 161.07H0.740433Z",
    fill: "url(#paint16_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 159.14V160.63V160.93L0.300003 161.23L0.600006 160.93V160.63V159.74L0 159.14Z",
    fill: "url(#paint17_linear_2371_121359)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92964 181.55L2.52965 180.95H0.139648L0.739655 181.55H1.92964Z",
    fill: "url(#paint18_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 182.88L2.37032 183.18L2.67032 182.88V181.09L2.07031 181.69V182.88Z",
    fill: "url(#paint19_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 183.76V184.95L2.67032 185.55V183.76L2.37032 183.46L2.07031 183.76Z",
    fill: "url(#paint20_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 185.09L0.139648 185.69H2.52965L1.92964 185.09H0.739655Z",
    fill: "url(#paint21_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 183.76L0.300003 183.46L0 183.76V185.55L0.600006 184.95V183.76Z",
    fill: "url(#paint22_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 181.69L0 181.09V182.88L0.300003 183.18L0.600006 182.88V182.58V181.69Z",
    fill: "url(#paint23_linear_2371_121359)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92964 176.06L2.52965 175.46H0.139648L0.739655 176.06H1.92964Z",
    fill: "url(#paint24_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 177.39L2.37032 177.69L2.67032 177.39V175.6L2.07031 176.2V177.39Z",
    fill: "url(#paint25_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 179.6L0.139648 180.2H2.52965L1.92964 179.6H0.739655Z",
    fill: "url(#paint26_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 178.27L0.300003 177.97L0 178.27V180.06L0.600006 179.46V178.27Z",
    fill: "url(#paint27_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740433 177.53L0.44043 177.83L0.740433 178.13H1.93042L2.23042 177.83L1.93042 177.53H0.740433Z",
    fill: "url(#paint28_linear_2371_121359)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92964 203.5L2.52965 202.89H0.139648L0.739655 203.5H1.92964Z",
    fill: "url(#paint29_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 204.82L2.37032 205.13L2.67032 204.82V203.04L2.07031 203.64V204.82Z",
    fill: "url(#paint30_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 207.04L0.139648 207.64H2.52965L1.92964 207.04H0.739655Z",
    fill: "url(#paint31_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 205.71L0.300003 205.41L0 205.71V207.5L0.600006 206.9V205.71Z",
    fill: "url(#paint32_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740433 204.97L0.44043 205.27L0.740433 205.57H1.93042L2.23042 205.27L1.93042 204.97H0.740433Z",
    fill: "url(#paint33_linear_2371_121359)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92964 198.01L2.52965 197.41H0.139648L0.739655 198.01H1.92964Z",
    fill: "url(#paint34_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 199.34L2.37032 199.64L2.67032 199.34V197.55L2.07031 198.15V199.34Z",
    fill: "url(#paint35_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 200.22V201.41L2.67032 202.01V200.22L2.37032 199.92L2.07031 200.22Z",
    fill: "url(#paint36_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 201.55L0.139648 202.15H2.52965L1.92964 201.55H0.739655Z",
    fill: "url(#paint37_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 200.22L0.300003 199.92L0 200.22V202.01L0.600006 201.41V200.22Z",
    fill: "url(#paint38_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 198.15L0 197.55V199.34L0.300003 199.64L0.600006 199.34V199.04V198.15Z",
    fill: "url(#paint39_linear_2371_121359)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 193.85L2.37032 194.15L2.67032 193.85V192.06L2.07031 192.66V193.85Z",
    fill: "url(#paint40_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 194.73V195.92L2.67032 196.52V194.73L2.37032 194.43L2.07031 194.73Z",
    fill: "url(#paint41_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740433 193.99L0.44043 194.29L0.740433 194.59H1.93042L2.23042 194.29L1.93042 193.99H0.740433Z",
    fill: "url(#paint42_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 192.06V193.56V193.85L0.300003 194.15L0.600006 193.85V193.56V192.66L0 192.06Z",
    fill: "url(#paint43_linear_2371_121359)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92964 219.96L2.52965 219.36H0.139648L0.739655 219.96H1.92964Z",
    fill: "url(#paint44_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 222.17V223.36L2.67032 223.96V222.17L2.37032 221.87L2.07031 222.17Z",
    fill: "url(#paint45_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 223.5L0.139648 224.1H2.52965L1.92964 223.5H0.739655Z",
    fill: "url(#paint46_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740433 221.43L0.44043 221.73L0.740433 222.03H1.93042L2.23042 221.73L1.93042 221.43H0.740433Z",
    fill: "url(#paint47_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 220.1L0 219.5V221.29L0.300003 221.59L0.600006 221.29V220.99V220.1Z",
    fill: "url(#paint48_linear_2371_121359)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92964 214.47L2.52965 213.87H0.139648L0.739655 214.47H1.92964Z",
    fill: "url(#paint49_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 215.8L2.37032 216.1L2.67032 215.8V214.01L2.07031 214.61V215.8Z",
    fill: "url(#paint50_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 216.68V217.87L2.67032 218.47V216.68L2.37032 216.38L2.07031 216.68Z",
    fill: "url(#paint51_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 218.01L0.139648 218.61H2.52965L1.92964 218.01H0.739655Z",
    fill: "url(#paint52_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740433 215.94L0.44043 216.24L0.740433 216.54H1.93042L2.23042 216.24L1.93042 215.94H0.740433Z",
    fill: "url(#paint53_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 214.61L0 214.01V215.8L0.300003 216.1L0.600006 215.8V215.5V214.61Z",
    fill: "url(#paint54_linear_2371_121359)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92964 208.98L2.52965 208.38H0.139648L0.739655 208.98H1.92964Z",
    fill: "url(#paint55_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 211.2V212.38L2.67032 212.98V211.2L2.37032 210.9L2.07031 211.2Z",
    fill: "url(#paint56_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 212.53L0.139648 213.13H2.52965L1.92964 212.53H0.739655Z",
    fill: "url(#paint57_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 211.2L0.300003 210.9L0 211.2V212.98L0.600006 212.38V211.2Z",
    fill: "url(#paint58_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740433 210.45L0.44043 210.75L0.740433 211.05H1.93042L2.23042 210.75L1.93042 210.45H0.740433Z",
    fill: "url(#paint59_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 208.52V210.02V210.31L0.300003 210.61L0.600006 210.31V210.02V209.13L0 208.52Z",
    fill: "url(#paint60_linear_2371_121359)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 226.77L2.37032 227.07L2.67032 226.77V224.99L2.07031 225.59V226.77Z",
    fill: "url(#paint61_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 227.66V228.85L2.67032 229.45V227.66L2.37032 227.36L2.07031 227.66Z",
    fill: "url(#paint62_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740433 226.92L0.44043 227.22L0.740433 227.52H1.93042L2.23042 227.22L1.93042 226.92H0.740433Z",
    fill: "url(#paint63_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 224.99V226.48V226.77L0.300003 227.07L0.600006 226.77V226.48V225.59L0 224.99Z",
    fill: "url(#paint64_linear_2371_121359)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 0.6L3.54037 0H1.15039L1.7504 0.6H2.93039Z",
    fill: "url(#paint65_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 1.92989L3.3801 2.22989L3.68008 1.92989V0.139893L3.08008 0.749892V1.92989Z",
    fill: "url(#paint66_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 2.82002V4.00002L3.68008 4.61002V2.82002L3.3801 2.52002L3.08008 2.82002Z",
    fill: "url(#paint67_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 4.1499L1.15039 4.7499H3.54037L2.93039 4.1499H1.7504Z",
    fill: "url(#paint68_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 2.82002L1.31 2.52002L1 2.82002V4.61002L1.60999 4.00002V2.82002Z",
    fill: "url(#paint69_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 2.07007L1.4502 2.37007L1.75021 2.68007H2.93021L3.23019 2.37007L2.93021 2.07007H1.75021Z",
    fill: "url(#paint70_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 0.749892L1 0.139893V1.92989L1.31 2.22989L1.60999 1.92989V1.63989V0.749892Z",
    fill: "url(#paint71_linear_2371_121359)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 17.07L3.54037 16.46H1.15039L1.7504 17.07H2.93039Z",
    fill: "url(#paint72_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 18.3899L3.3801 18.6899L3.68008 18.3899V16.6099L3.08008 17.2099V18.3899Z",
    fill: "url(#paint73_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 19.28V20.47L3.68008 21.07V19.28L3.3801 18.98L3.08008 19.28Z",
    fill: "url(#paint74_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 20.6099L1.15039 21.2099H3.54037L2.93039 20.6099H1.7504Z",
    fill: "url(#paint75_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 18.54L1.4502 18.84L1.75021 19.14H2.93021L3.23019 18.84L2.93021 18.54H1.75021Z",
    fill: "url(#paint76_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 17.2099L1 16.6099V18.3899L1.31 18.6899L1.60999 18.3899V18.0999V17.2099Z",
    fill: "url(#paint77_linear_2371_121359)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 11.58L3.54037 10.98H1.15039L1.7504 11.58H2.93039Z",
    fill: "url(#paint78_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 12.9099L3.3801 13.2099L3.68008 12.9099V11.1199L3.08008 11.7199V12.9099Z",
    fill: "url(#paint79_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 13.79V14.98L3.68008 15.58V13.79L3.3801 13.49L3.08008 13.79Z",
    fill: "url(#paint80_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 15.1199L1.15039 15.7199H3.54037L2.93039 15.1199H1.7504Z",
    fill: "url(#paint81_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 13.79L1.31 13.49L1 13.79V15.58L1.60999 14.98V13.79Z",
    fill: "url(#paint82_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 13.05L1.4502 13.35L1.75021 13.65H2.93021L3.23019 13.35L2.93021 13.05H1.75021Z",
    fill: "url(#paint83_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 11.7199L1 11.1199V12.9099L1.31 13.2099L1.60999 12.9099V12.6099V11.7199Z",
    fill: "url(#paint84_linear_2371_121359)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 6.08999L3.54037 5.48999H1.15039L1.7504 6.08999H2.93039Z",
    fill: "url(#paint85_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 7.41988L3.3801 7.71988L3.68008 7.41988V5.62988L3.08008 6.22988V7.41988Z",
    fill: "url(#paint86_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 8.3V9.49L3.68008 10.09V8.3L3.3801 8L3.08008 8.3Z",
    fill: "url(#paint87_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 9.62988L1.15039 10.2299H3.54037L2.93039 9.62988H1.7504Z",
    fill: "url(#paint88_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 8.3L1.31 8L1 8.3V10.09L1.60999 9.49V8.3Z",
    fill: "url(#paint89_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 7.56006L1.4502 7.86006L1.75021 8.16006H2.93021L3.23019 7.86006L2.93021 7.56006H1.75021Z",
    fill: "url(#paint90_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 5.62988V7.11988V7.41988L1.31 7.71988L1.60999 7.41988V7.11988V6.22988L1 5.62988Z",
    fill: "url(#paint91_linear_2371_121359)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 33.5299L3.54037 32.9299H1.15039L1.7504 33.5299H2.93039Z",
    fill: "url(#paint92_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 34.8598L3.3801 35.1598L3.68008 34.8598V33.0698L3.08008 33.6698V34.8598Z",
    fill: "url(#paint93_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 35.7399V36.9299L3.68008 37.5299V35.7399L3.3801 35.4399L3.08008 35.7399Z",
    fill: "url(#paint94_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 37.0698L1.15039 37.6698H3.54037L2.93039 37.0698H1.7504Z",
    fill: "url(#paint95_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 35L1.4502 35.3L1.75021 35.6H2.93021L3.23019 35.3L2.93021 35H1.75021Z",
    fill: "url(#paint96_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 33.6698L1 33.0698V34.8598L1.31 35.1598L1.60999 34.8598V34.5598V33.6698Z",
    fill: "url(#paint97_linear_2371_121359)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 28.0399L3.54037 27.4399H1.15039L1.7504 28.0399H2.93039Z",
    fill: "url(#paint98_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 29.3698L3.3801 29.6698L3.68008 29.3698V27.5798L3.08008 28.1798V29.3698Z",
    fill: "url(#paint99_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 30.25V31.4399L3.68008 32.04V30.25L3.3801 29.95L3.08008 30.25Z",
    fill: "url(#paint100_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 31.5798L1.15039 32.1798H3.54037L2.93039 31.5798H1.7504Z",
    fill: "url(#paint101_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 30.25L1.31 29.95L1 30.25V32.04L1.60999 31.4399V30.25Z",
    fill: "url(#paint102_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 28.1798L1 27.5798V29.3698L1.31 29.6698L1.60999 29.3698V29.0698V28.1798Z",
    fill: "url(#paint103_linear_2371_121359)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 22.5499L3.54037 21.95H1.15039L1.7504 22.5499H2.93039Z",
    fill: "url(#paint104_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 23.8798L3.3801 24.1798L3.68008 23.8798V22.0898L3.08008 22.6898V23.8798Z",
    fill: "url(#paint105_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 24.77V25.95L3.68008 26.55V24.77L3.3801 24.47L3.08008 24.77Z",
    fill: "url(#paint106_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 26.0898L1.15039 26.6998H3.54037L2.93039 26.0898H1.7504Z",
    fill: "url(#paint107_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 24.02L1.4502 24.32L1.75021 24.62H2.93021L3.23019 24.32L2.93021 24.02H1.75021Z",
    fill: "url(#paint108_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 22.0898V23.5898V23.8798L1.31 24.1798L1.60999 23.8798V23.5898V22.6898L1 22.0898Z",
    fill: "url(#paint109_linear_2371_121359)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.37
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 49.9899L3.54037 49.3899H1.15039L1.7504 49.9899H2.93039Z",
    fill: "url(#paint110_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 51.3198L3.3801 51.6198L3.68008 51.3198V49.5298L3.08008 50.1298V51.3198Z",
    fill: "url(#paint111_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 52.1999V53.3899L3.68008 53.9899V52.1999L3.3801 51.8999L3.08008 52.1999Z",
    fill: "url(#paint112_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 53.5298L1.15039 54.1298H3.54037L2.93039 53.5298H1.7504Z",
    fill: "url(#paint113_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 51.46L1.4502 51.76L1.75021 52.06H2.93021L3.23019 51.76L2.93021 51.46H1.75021Z",
    fill: "url(#paint114_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 50.1298L1 49.5298V51.3198L1.31 51.6198L1.60999 51.3198V51.0198V50.1298Z",
    fill: "url(#paint115_linear_2371_121359)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 44.4999L3.54037 43.8999H1.15039L1.7504 44.4999H2.93039Z",
    fill: "url(#paint116_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 45.8298L3.3801 46.1298L3.68008 45.8298V44.0398L3.08008 44.6398V45.8298Z",
    fill: "url(#paint117_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 46.7199V47.8999L3.68008 48.4999V46.7199L3.3801 46.4099L3.08008 46.7199Z",
    fill: "url(#paint118_linear_2371_121359)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 39.0099L3.54037 38.4099H1.15039L1.7504 39.0099H2.93039Z",
    fill: "url(#paint119_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 40.3398L3.3801 40.6398L3.68008 40.3398V38.5598L3.08008 39.1598V40.3398Z",
    fill: "url(#paint120_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 41.2299V42.4099L3.68008 43.0199V41.2299L3.3801 40.9299L3.08008 41.2299Z",
    fill: "url(#paint121_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 42.5598L1.15039 43.1598H3.54037L2.93039 42.5598H1.7504Z",
    fill: "url(#paint122_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 40.48L1.4502 40.79L1.75021 41.09H2.93021L3.23019 40.79L2.93021 40.48H1.75021Z",
    fill: "url(#paint123_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 38.5598V40.0498V40.3398L1.31 40.6398L1.60999 40.3398V40.0498V39.1598L1 38.5598Z",
    fill: "url(#paint124_linear_2371_121359)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 67.78L3.3801 68.08L3.68008 67.78V65.99L3.08008 66.59V67.78Z",
    fill: "url(#paint125_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 68.6599V69.8499L3.68008 70.4499V68.6599L3.3801 68.3599L3.08008 68.6599Z",
    fill: "url(#paint126_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 67.9199L1.4502 68.2199L1.75021 68.5199H2.93021L3.23019 68.2199L2.93021 67.9199H1.75021Z",
    fill: "url(#paint127_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 66.59L1 65.99V67.78L1.31 68.08L1.60999 67.78V67.48V66.59Z",
    fill: "url(#paint128_linear_2371_121359)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 60.9599L3.54037 60.3599H1.15039L1.7504 60.9599H2.93039Z",
    fill: "url(#paint129_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 62.2898L3.3801 62.5898L3.68008 62.2898V60.4998L3.08008 61.1098V62.2898Z",
    fill: "url(#paint130_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 63.1799V64.3599L3.68008 64.9699V63.1799L3.3801 62.8799L3.08008 63.1799Z",
    fill: "url(#paint131_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 64.5098L1.15039 65.1098H3.54037L2.93039 64.5098H1.7504Z",
    fill: "url(#paint132_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 63.1799L1.31 62.8799L1 63.1799V64.9699L1.60999 64.3599V63.1799Z",
    fill: "url(#paint133_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 61.1098L1 60.4998V62.2898L1.31 62.5898L1.60999 62.2898V61.9998V61.1098Z",
    fill: "url(#paint134_linear_2371_121359)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 55.4799L3.54037 54.8799H1.15039L1.7504 55.4799H2.93039Z",
    fill: "url(#paint135_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 57.6899V58.8799L3.68008 59.4799V57.6899L3.3801 57.3899L3.08008 57.6899Z",
    fill: "url(#paint136_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 59.0198L1.15039 59.6198H3.54037L2.93039 59.0198H1.7504Z",
    fill: "url(#paint137_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 57.6899L1.31 57.3899L1 57.6899V59.4799L1.60999 58.8799V57.6899Z",
    fill: "url(#paint138_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 56.95L1.4502 57.25L1.75021 57.5499H2.93021L3.23019 57.25L2.93021 56.95H1.75021Z",
    fill: "url(#paint139_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 55.0198V56.5098V56.7998L1.31 57.1098L1.60999 56.7998V56.5098V55.6198L1 55.0198Z",
    fill: "url(#paint140_linear_2371_121359)"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 82.9098L3.54037 82.3098H1.15039L1.7504 82.9098H2.93039Z",
    fill: "url(#paint141_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 84.2397L3.3801 84.5397L3.68008 84.2397V82.4497L3.08008 83.0497V84.2397Z",
    fill: "url(#paint142_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 85.1298V86.3098L3.68008 86.9098V85.1298L3.3801 84.8298L3.08008 85.1298Z",
    fill: "url(#paint143_linear_2371_121359)"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 77.4298L3.54037 76.8198H1.15039L1.7504 77.4298H2.93039Z",
    fill: "url(#paint144_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 78.7497L3.3801 79.0497L3.68008 78.7497V76.9697L3.08008 77.5697V78.7497Z",
    fill: "url(#paint145_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 79.6398V80.8298L3.68008 81.4298V79.6398L3.3801 79.3398L3.08008 79.6398Z",
    fill: "url(#paint146_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 80.9697L1.15039 81.5697H3.54037L2.93039 80.9697H1.7504Z",
    fill: "url(#paint147_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 79.6398L1.31 79.3398L1 79.6398V81.4298L1.60999 80.8298V79.6398Z",
    fill: "url(#paint148_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 78.8999L1.4502 79.1999L1.75021 79.4999H2.93021L3.23019 79.1999L2.93021 78.8999H1.75021Z",
    fill: "url(#paint149_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 77.5697L1 76.9697V78.7497L1.31 79.0497L1.60999 78.7497V78.4597V77.5697Z",
    fill: "url(#paint150_linear_2371_121359)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 71.9398L3.54037 71.3398H1.15039L1.7504 71.9398H2.93039Z",
    fill: "url(#paint151_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 73.2697L3.3801 73.5697L3.68008 73.2697V71.4797L3.08008 72.0797V73.2697Z",
    fill: "url(#paint152_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 74.1498V75.3399L3.68008 75.9398V74.1498L3.3801 73.8499L3.08008 74.1498Z",
    fill: "url(#paint153_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 75.4797L1.15039 76.0797H3.54037L2.93039 75.4797H1.7504Z",
    fill: "url(#paint154_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 73.4099L1.4502 73.7099L1.75021 74.0099H2.93021L3.23019 73.7099L2.93021 73.4099H1.75021Z",
    fill: "url(#paint155_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 71.4797V72.9697V73.2697L1.31 73.5697L1.60999 73.2697V72.9697V72.0797L1 71.4797Z",
    fill: "url(#paint156_linear_2371_121359)"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 99.37L3.54037 98.77H1.15039L1.7504 99.37H2.93039Z",
    fill: "url(#paint157_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 100.7L3.3801 101L3.68008 100.7V98.9199L3.08008 99.5199V100.7Z",
    fill: "url(#paint158_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 101.59V102.77L3.68008 103.38V101.59L3.3801 101.29L3.08008 101.59Z",
    fill: "url(#paint159_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 102.92L1.15039 103.52H3.54037L2.93039 102.92H1.7504Z",
    fill: "url(#paint160_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 101.59L1.31 101.29L1 101.59V103.38L1.60999 102.77V101.59Z",
    fill: "url(#paint161_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 100.84L1.4502 101.15L1.75021 101.45H2.93021L3.23019 101.15L2.93021 100.84H1.75021Z",
    fill: "url(#paint162_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 99.5199L1 98.9199V100.7L1.31 101L1.60999 100.7V100.41V99.5199Z",
    fill: "url(#paint163_linear_2371_121359)"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 93.8898L3.54037 93.2898H1.15039L1.7504 93.8898H2.93039Z",
    fill: "url(#paint164_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 95.2197L3.3801 95.5197L3.68008 95.2197V93.4297L3.08008 94.0297V95.2197Z",
    fill: "url(#paint165_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 97.4297L1.15039 98.0297H3.54037L2.93039 97.4297H1.7504Z",
    fill: "url(#paint166_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 96.0998L1.31 95.7998L1 96.0998V97.8898L1.60999 97.2898V96.0998Z",
    fill: "url(#paint167_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 95.3599L1.4502 95.6599L1.75021 95.9599H2.93021L3.23019 95.6599L2.93021 95.3599H1.75021Z",
    fill: "url(#paint168_linear_2371_121359)"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.59
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 88.3998L3.54037 87.7998H1.15039L1.7504 88.3998H2.93039Z",
    fill: "url(#paint169_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 89.7297L3.3801 90.0297L3.68008 89.7297V87.9397L3.08008 88.5397V89.7297Z",
    fill: "url(#paint170_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 90.6098V91.7998L3.68008 92.3998V90.6098L3.3801 90.3098L3.08008 90.6098Z",
    fill: "url(#paint171_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 91.9397L1.15039 92.5397H3.54037L2.93039 91.9397H1.7504Z",
    fill: "url(#paint172_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 90.6098L1.31 90.3098L1 90.6098V92.3998L1.60999 91.7998V90.6098Z",
    fill: "url(#paint173_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 87.9397V89.4297V89.7297L1.31 90.0297L1.60999 89.7297V89.4297V88.5397L1 87.9397Z",
    fill: "url(#paint174_linear_2371_121359)"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 115.84L3.54037 115.24H1.15039L1.7504 115.84H2.93039Z",
    fill: "url(#paint175_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 117.16L3.3801 117.47L3.68008 117.16V115.38L3.08008 115.98V117.16Z",
    fill: "url(#paint176_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 119.38L1.15039 119.98H3.54037L2.93039 119.38H1.7504Z",
    fill: "url(#paint177_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 118.05L1.31 117.75L1 118.05V119.84L1.60999 119.24V118.05Z",
    fill: "url(#paint178_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 117.31L1.4502 117.61L1.75021 117.91H2.93021L3.23019 117.61L2.93021 117.31H1.75021Z",
    fill: "url(#paint179_linear_2371_121359)"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 111.68L3.3801 111.98L3.68008 111.68V109.89L3.08008 110.49V111.68Z",
    fill: "url(#paint180_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 112.56V113.75L3.68008 114.35V112.56L3.3801 112.26L3.08008 112.56Z",
    fill: "url(#paint181_linear_2371_121359)"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 104.86L3.54037 104.26H1.15039L1.7504 104.86H2.93039Z",
    fill: "url(#paint182_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 106.19L3.3801 106.49L3.68008 106.19V104.4L3.08008 105V106.19Z",
    fill: "url(#paint183_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 107.08V108.26L3.68008 108.86V107.08L3.3801 106.77L3.08008 107.08Z",
    fill: "url(#paint184_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 108.4L1.15039 109H3.54037L2.93039 108.4H1.7504Z",
    fill: "url(#paint185_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 107.08L1.31 106.77L1 107.08V108.86L1.60999 108.26V107.08Z",
    fill: "url(#paint186_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 104.4V105.9V106.19L1.31 106.49L1.60999 106.19V105.9V105L1 104.4Z",
    fill: "url(#paint187_linear_2371_121359)"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.37
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 132.3L3.54037 131.7H1.15039L1.7504 132.3H2.93039Z",
    fill: "url(#paint188_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 133.63L3.3801 133.93L3.68008 133.63V131.84L3.08008 132.44V133.63Z",
    fill: "url(#paint189_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 134.51V135.7L3.68008 136.3V134.51L3.3801 134.21L3.08008 134.51Z",
    fill: "url(#paint190_linear_2371_121359)"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 126.81L3.54037 126.21H1.15039L1.7504 126.81H2.93039Z",
    fill: "url(#paint191_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 128.14L3.3801 128.44L3.68008 128.14V126.35L3.08008 126.95V128.14Z",
    fill: "url(#paint192_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 129.02V130.21L3.68008 130.81V129.02L3.3801 128.72L3.08008 129.02Z",
    fill: "url(#paint193_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 130.35L1.15039 130.95H3.54037L2.93039 130.35H1.7504Z",
    fill: "url(#paint194_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 128.28L1.4502 128.58L1.75021 128.88H2.93021L3.23019 128.58L2.93021 128.28H1.75021Z",
    fill: "url(#paint195_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 126.95L1 126.35V128.14L1.31 128.44L1.60999 128.14V127.84V126.95Z",
    fill: "url(#paint196_linear_2371_121359)"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 121.32L3.54037 120.72H1.15039L1.7504 121.32H2.93039Z",
    fill: "url(#paint197_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 122.65L3.3801 122.95L3.68008 122.65V120.86L3.08008 121.47V122.65Z",
    fill: "url(#paint198_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 123.54V124.72L3.68008 125.32V123.54L3.3801 123.24L3.08008 123.54Z",
    fill: "url(#paint199_linear_2371_121359)"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 148.76L3.54037 148.16H1.15039L1.7504 148.76H2.93039Z",
    fill: "url(#paint200_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 150.09L3.3801 150.39L3.68008 150.09V148.3L3.08008 148.9V150.09Z",
    fill: "url(#paint201_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 152.3L1.15039 152.9H3.54037L2.93039 152.3H1.7504Z",
    fill: "url(#paint202_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 150.97L1.31 150.67L1 150.97V152.76L1.60999 152.16V150.97Z",
    fill: "url(#paint203_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 150.23L1.4502 150.53L1.75021 150.83H2.93021L3.23019 150.53L2.93021 150.23H1.75021Z",
    fill: "url(#paint204_linear_2371_121359)"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 144.6L3.3801 144.9L3.68008 144.6V142.81L3.08008 143.41V144.6Z",
    fill: "url(#paint205_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 145.49V146.67L3.68008 147.27V145.49L3.3801 145.19L3.08008 145.49Z",
    fill: "url(#paint206_linear_2371_121359)"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 137.79L3.54037 137.18H1.15039L1.7504 137.79H2.93039Z",
    fill: "url(#paint207_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 140V141.19L3.68008 141.79V140L3.3801 139.7L3.08008 140Z",
    fill: "url(#paint208_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 141.33L1.15039 141.93H3.54037L2.93039 141.33H1.7504Z",
    fill: "url(#paint209_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 140L1.31 139.7L1 140V141.79L1.60999 141.19V140Z",
    fill: "url(#paint210_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 139.26L1.4502 139.56L1.75021 139.86H2.93021L3.23019 139.56L2.93021 139.26H1.75021Z",
    fill: "url(#paint211_linear_2371_121359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 137.33V138.82V139.11L1.31 139.41L1.60999 139.11V138.82V137.93L1 137.33Z",
    fill: "url(#paint212_linear_2371_121359)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2371_121359",
    x1: 1.32965,
    y1: 341.712,
    x2: 1.32965,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2371_121359",
    x1: 2.37031,
    y1: 341.711,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2371_121359",
    x1: 2.37031,
    y1: 341.71,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2371_121359",
    x1: 1.32965,
    y1: 341.71,
    x2: 1.32965,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2371_121359",
    x1: 0.300001,
    y1: 341.71,
    x2: 0.300001,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2371_121359",
    x1: 1.33043,
    y1: 341.712,
    x2: 1.33043,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2371_121359",
    x1: 0.300001,
    y1: 341.711,
    x2: 0.300001,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2371_121359",
    x1: 1.32965,
    y1: 341.71,
    x2: 1.32965,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2371_121359",
    x1: 2.37031,
    y1: 341.71,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2371_121359",
    x1: 1.32965,
    y1: 341.712,
    x2: 1.32965,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2371_121359",
    x1: 1.33043,
    y1: 341.707,
    x2: 1.33043,
    y2: 133.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2371_121359",
    x1: 0.300005,
    y1: 341.7,
    x2: 0.300005,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2371_121359",
    x1: 1.32965,
    y1: 341.677,
    x2: 1.32965,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2371_121359",
    x1: 2.37031,
    y1: 341.71,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2371_121359",
    x1: 2.37031,
    y1: 341.71,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2371_121359",
    x1: 1.32965,
    y1: 341.707,
    x2: 1.32965,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2371_121359",
    x1: 1.33043,
    y1: 341.712,
    x2: 1.33043,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2371_121359",
    x1: 0.300001,
    y1: 341.71,
    x2: 0.300001,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2371_121359",
    x1: 1.32965,
    y1: 341.708,
    x2: 1.32965,
    y2: 133.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2371_121359",
    x1: 2.37031,
    y1: 341.71,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2371_121359",
    x1: 2.37031,
    y1: 341.71,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2371_121359",
    x1: 1.32965,
    y1: 341.707,
    x2: 1.32965,
    y2: 133.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2371_121359",
    x1: 0.300001,
    y1: 341.71,
    x2: 0.300001,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2371_121359",
    x1: 0.300001,
    y1: 341.71,
    x2: 0.300001,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2371_121359",
    x1: 1.32965,
    y1: 341.712,
    x2: 1.32965,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2371_121359",
    x1: 2.37031,
    y1: 341.71,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2371_121359",
    x1: 1.32965,
    y1: 341.712,
    x2: 1.32965,
    y2: 133.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2371_121359",
    x1: 0.300001,
    y1: 341.711,
    x2: 0.300001,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2371_121359",
    x1: 1.33043,
    y1: 341.708,
    x2: 1.33043,
    y2: 133.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2371_121359",
    x1: 1.32965,
    y1: 341.71,
    x2: 1.32965,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2371_121359",
    x1: 2.37031,
    y1: 341.71,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2371_121359",
    x1: 1.32965,
    y1: 341.711,
    x2: 1.32965,
    y2: 133.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2371_121359",
    x1: 0.300001,
    y1: 341.711,
    x2: 0.300001,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2371_121359",
    x1: 1.33043,
    y1: 341.711,
    x2: 1.33043,
    y2: 133.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2371_121359",
    x1: 1.32965,
    y1: 341.711,
    x2: 1.32965,
    y2: 133.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2371_121359",
    x1: 2.37031,
    y1: 341.711,
    x2: 2.37031,
    y2: 133.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2371_121359",
    x1: 2.37031,
    y1: 341.71,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2371_121359",
    x1: 1.32965,
    y1: 341.711,
    x2: 1.32965,
    y2: 133.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2371_121359",
    x1: 0.300001,
    y1: 341.71,
    x2: 0.300001,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2371_121359",
    x1: 0.300001,
    y1: 341.711,
    x2: 0.300001,
    y2: 133.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2371_121359",
    x1: 2.37031,
    y1: 341.71,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2371_121359",
    x1: 2.37031,
    y1: 341.709,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2371_121359",
    x1: 1.33043,
    y1: 341.711,
    x2: 1.33043,
    y2: 133.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2371_121359",
    x1: 0.300001,
    y1: 341.71,
    x2: 0.300001,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2371_121359",
    x1: 1.32965,
    y1: 341.711,
    x2: 1.32965,
    y2: 133.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2371_121359",
    x1: 2.37031,
    y1: 341.71,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2371_121359",
    x1: 1.32965,
    y1: 341.708,
    x2: 1.32965,
    y2: 133.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2371_121359",
    x1: 1.33043,
    y1: 341.711,
    x2: 1.33043,
    y2: 133.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2371_121359",
    x1: 0.300001,
    y1: 341.71,
    x2: 0.300001,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2371_121359",
    x1: 1.32965,
    y1: 341.708,
    x2: 1.32965,
    y2: 133.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2371_121359",
    x1: 2.37032,
    y1: 341.7,
    x2: 2.37032,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2371_121359",
    x1: 2.37031,
    y1: 341.71,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2371_121359",
    x1: 1.32965,
    y1: 341.708,
    x2: 1.32965,
    y2: 133.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2371_121359",
    x1: 1.33043,
    y1: 341.711,
    x2: 1.33043,
    y2: 133.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2371_121359",
    x1: 0.300005,
    y1: 341.7,
    x2: 0.300005,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2371_121359",
    x1: 1.32965,
    y1: 341.711,
    x2: 1.32965,
    y2: 133.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2371_121359",
    x1: 2.37031,
    y1: 341.71,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2371_121359",
    x1: 1.32965,
    y1: 341.708,
    x2: 1.32965,
    y2: 133.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2371_121359",
    x1: 0.300001,
    y1: 341.71,
    x2: 0.300001,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2371_121359",
    x1: 1.33043,
    y1: 341.708,
    x2: 1.33043,
    y2: 133.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2371_121359",
    x1: 0.300001,
    y1: 341.71,
    x2: 0.300001,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2371_121359",
    x1: 2.37031,
    y1: 341.71,
    x2: 2.37031,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2371_121359",
    x1: 2.37031,
    y1: 341.71,
    x2: 2.37031,
    y2: 133.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2371_121359",
    x1: 1.33043,
    y1: 341.708,
    x2: 1.33043,
    y2: 133.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2371_121359",
    x1: 0.300001,
    y1: 341.71,
    x2: 0.300001,
    y2: 133.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.7701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.76998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.7701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.76998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.76993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.7701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.76997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2371_121359",
    x1: 3.38008,
    y1: 155.41,
    x2: 3.38008,
    y2: -5.77013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.76993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2371_121359",
    x1: 1.30999,
    y1: 155.41,
    x2: 1.30999,
    y2: -5.77013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2371_121359",
    x1: 2.34019,
    y1: 155.41,
    x2: 2.34019,
    y2: -5.76995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.76997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.76989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.76997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.76998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.76991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2371_121359",
    x1: 3.38008,
    y1: 155.41,
    x2: 3.38008,
    y2: -5.77022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.7701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.77026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2371_121359",
    x1: 2.34038,
    y1: 155.4,
    x2: 2.34038,
    y2: -5.75998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.76998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2371_121359",
    x1: 2.34038,
    y1: 155.4,
    x2: 2.34038,
    y2: -5.76006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.77007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.76988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.7699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.76988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.76997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.76996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.76989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.76997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2371_121359",
    x1: 2.34038,
    y1: 155.419,
    x2: 2.34038,
    y2: -5.76923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.76988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.76996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.76989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.76972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.75979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.76981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.77002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.76979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.7705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.77117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.76996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2371_121359",
    x1: 2.34038,
    y1: 155.41,
    x2: 2.34038,
    y2: -5.75006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.7697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.76991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.7698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.76963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.7699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.76971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.76978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.76981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.76978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.75145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.7698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.76803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.76992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.76979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_2371_121359",
    x1: 2.34038,
    y1: 155.419,
    x2: 2.34038,
    y2: -5.74807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.77134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.76992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.76993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.76764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2371_121359",
    x1: 3.38008,
    y1: 155.42,
    x2: 3.38008,
    y2: -5.77086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2371_121359",
    x1: 2.34038,
    y1: 155.42,
    x2: 2.34038,
    y2: -5.77167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.77086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2371_121359",
    x1: 2.3402,
    y1: 155.42,
    x2: 2.3402,
    y2: -5.76778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_2371_121359",
    x1: 1.30999,
    y1: 155.42,
    x2: 1.30999,
    y2: -5.7603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrix3);
export default __webpack_public_path__ + "static/media/matrix-3.295e33ff3ae720dfb6897c7d232e2b84.svg";
export { ForwardRef as ReactComponent };